// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Turks & Caicos Islands */
const TC: PhoneNumberData = [1, 'TC', 10, format0, /^(?:649)/];

export default TC;
